import { render, staticRenderFns } from "./PdfModal.vue?vue&type=template&id=2f5dc78d&scoped=true&lang=pug"
import script from "./PdfModal.vue?vue&type=script&lang=ts"
export * from "./PdfModal.vue?vue&type=script&lang=ts"
import style0 from "./PdfModal.vue?vue&type=style&index=0&id=2f5dc78d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5dc78d",
  null
  
)

export default component.exports